import styled, { css } from 'styled-components';
import { Link as CustomLink } from 'react-router-dom';

export const paginationButtonDefaultStyles = css`
  padding: 0.8rem 1.2rem;
  display: flex;
  align-items: center;
  font-weight: 400;
  background-color: ${(props) => props.theme.config.colors.light};
  color: ${(props) => props.theme.config.colors.light};
  border: none;
  cursor: pointer;
  outline: none;
  transition: background-color 0.2s ease;

  svg {
    width: 1.4rem;

    path {
      fill: ${(props) => props.theme.config.colors.text_base};
    }
  }
`;

const Text = styled.span`
  ${(props) => props.theme.config.typograph.xsmall};
`;

const Link = styled((props) => <CustomLink {...props} />)`
  ${paginationButtonDefaultStyles};
  margin-left: 1.2rem;
  border-left: 1px solid ${(props) => props.theme.config.colors.gray_200};

  ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
      cursor: default;
      opacity: 0.5;
    `};
`;

const Button = styled.button`
  ${paginationButtonDefaultStyles};
  margin-left: 1.2rem;
  border-left: 1px solid ${(props) => props.theme.config.colors.gray_200};

  ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
      cursor: default;
      opacity: 0.4;
    `};
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${(props) => props.theme.config.spacing.spacing_2};
`;

export { Link, Button, Text, IconContainer };
